import React from "react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "@heroui/react";
import { useTranslation } from "react-i18next";
import { IoWarningOutline } from "react-icons/io5";

type UnsavedChangesModalProps = {
  isOpen: boolean;
  onStay: () => void;
  onLeave: () => void;
};

const UnsavedChangesModal = ({
  isOpen,
  onStay,
  onLeave,
}: UnsavedChangesModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onStay}
      backdrop="opaque"
      placement="top-center"
      size="md"
      classNames={{
        backdrop:
          "bg-gradient-to-t from-vistadark/80 to-vistadark/60 backdrop-opacity-20",
      }}
    >
      <ModalContent>
        <ModalHeader className="flex items-center gap-2">
          <IoWarningOutline className="text-orange-500 text-xl" />
          <span className="text-sm">{t("unsaved_changes_title")}</span>
        </ModalHeader>
        <ModalBody>
          <p className="text-sm">{t("unsaved_changes_message")}</p>
        </ModalBody>
        <ModalFooter>
          <Button color="default" size="md" variant="flat" onPress={onStay}>
            {t("stay_on_page")}
          </Button>
          <Button color="primary" size="md" onPress={onLeave}>
            {t("leave_without_saving")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default UnsavedChangesModal;
